/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  PlanData,
  PlanDataFromJSON,
  PlanDataFromJSONTyped,
  PlanDataToJSON,
} from "./";

/**
 *
 * @export
 * @interface PlanDataControllerResponse
 */
export interface PlanDataControllerResponse {
  /**
   *
   * @type {PlanData}
   * @memberof PlanDataControllerResponse
   */
  data?: PlanData;
  /**
   *
   * @type {ErrorResponse}
   * @memberof PlanDataControllerResponse
   */
  error?: ErrorResponse;
}

export function PlanDataControllerResponseFromJSON(json: any): PlanDataControllerResponse {
  return PlanDataControllerResponseFromJSONTyped(json, false);
}

export function PlanDataControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PlanDataControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : PlanDataFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function PlanDataControllerResponseToJSON(value?: PlanDataControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: PlanDataToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
